/* tslint:disable */
/* eslint-disable */
/**
 * rb-c3po-warehouse
 * API für die Verwaltung von Warenausgangsaufträgen, Artikeln, Chargen und Seriennummern
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutboundSubOrder
 */
export interface OutboundSubOrder {
    /**
     * Teilauftragsnummer
     * @type {string}
     * @memberof OutboundSubOrder
     */
    orderNumber: string;
    /**
     * Lieferdatum des Teilauftrags
     * @type {Date}
     * @memberof OutboundSubOrder
     */
    deliveryDate: Date;
}

/**
 * Check if a given object implements the OutboundSubOrder interface.
 */
export function instanceOfOutboundSubOrder(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "orderNumber" in value;
    isInstance = isInstance && "deliveryDate" in value;

    return isInstance;
}

export function OutboundSubOrderFromJSON(json: any): OutboundSubOrder {
    return OutboundSubOrderFromJSONTyped(json, false);
}

export function OutboundSubOrderFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutboundSubOrder {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'orderNumber': json['orderNumber'],
        'deliveryDate': (new Date(json['deliveryDate'])),
    };
}

export function OutboundSubOrderToJSON(value?: OutboundSubOrder | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'orderNumber': value.orderNumber,
        'deliveryDate': (value.deliveryDate.toISOString().substr(0,10)),
    };
}

